import { ContentType } from '../models/ContentType';
import { SearchResultList, SearchResultItem } from '../models/SearchResultTypes';

export interface SingleContentTypeState {
  contentType?: ContentType;
  searchResults?: SearchResultList<SearchResultItem>;
}

export const initialState: SingleContentTypeState = {};
